import React from 'react';
import styles from './SGSColoredCard.module.scss';
import classnames from 'classnames';

type Props = {
    color: 'blue' | 'orange';
    title: string;
    image: any;
    alt: string;
    count: number | string;
    className?: string;
};

const SGSColoredCard: React.FC<Props> = ({ color, title, image, alt, count, className, children }) => {
    return (
        <div className={classnames(styles.card, styles[`card__${color}`], className)}>
            <div className={styles.card__count}>
                <div>
                    <img src={image} alt={alt} />
                </div>
                <div className={styles.card__count__number}>{count}</div>
            </div>
            <div className={styles.card__info}>
                <h4>{title}</h4>
                <div>{children}</div>
            </div>
        </div>
    );
};

export default SGSColoredCard;
